import { http_client } from "@/plugins/http_client";

const getInstituciones  = async () => await http_client('/api/solicitudes/instituciones', {}, "get");
const getUnidadOrganizativa  = async (params) => await http_client('/api/solicitudes/listar-unidades-institucion', params, "get");
const getCtlUnidadOrganizativa = async (params = {}) => await http_client('/api/listar-unidades-organizativas', params);
const getTiposDocumentos = async (params = {}) => await http_client('/api/solicitudes/tipos-documentos', params);
const showDocument = async (path) => await http_client(`/api/solicitudes/view-file?path=${path}`, {}, "get");
const downloadDocument = async (path) => await http_client(`/api/solicitudes/view-file?path=${path}`, {}, "get");

// Empleado
const getEmpleadoPlazaDetalle = async (id_empleado_puesto, id_solicitud_aumento) => {
  return await http_client(`/api/solicitudes/empleado-plaza-detalle?id_empleado_puesto=${id_empleado_puesto}&id_solicitud_aumento=${id_solicitud_aumento || ''}`, {}, "get");
}

const getDetalleSolicitudAumento = async (id_solicitud_aumento_salarial, id_empleado_puesto, step) =>
  await http_client(`/api/solicitudes/detalle-solicitud?id_solicitud_aumento_salarial=${id_solicitud_aumento_salarial}&id_empleado_puesto=${id_empleado_puesto}&step=${step}`, {}, "get");

const getDescargarArchivo = async (path) => {
  return await http_client(`/api/solicitudes/download-file-solcitud?path=${path}`, {}, "get");
}

const crearSolicitudAumento = async (data) => await http_client("/api/solicitudes/aumento", data, "post");

// Jefe unidad
const getPersona = async (params = {}) => await http_client('/api/v1/aumento/busqueda-persona', params)

const getSolicitudes = async (params = {}) => await http_client('/api/solicitudes/get-solicitudes', params)

// RRHH
const descargarAcuerdoAumento = async (params = {}) =>
  await http_client("/api/descargar-acuerdo", params, "get");

const verAcuerdoAumento = async (idSeguimiento, params = {}) =>
  await http_client(`api/nomina/expediente/historico-contratos/ver-contrato/${idSeguimiento}`, params, "get");

const rechazarSolicitudEmpleado = async (params) => await http_client("/api/solicitudes/subir-justificacion-exclusion", params, "post");

const subirAcuerdoAumento = async (params) => await http_client("/api/solicitudes/subir-acuerdo-firmado", params, "post");

// Titular
const getDetailSolicById = async (params) => {
  return await http_client(`/api/solicitudes/detalle-solicitud`, params);
}

const postAprobarSolicitud = async (id_movimiento, params) => {
  return await http_client(`/api/solicitudes/aumento/update/${id_movimiento}`, params, "post");
}

const postRechazarSolicitud = async (id_movimiento, params) => {
  return await http_client(`/api/solicitudes/aumento/decline/${id_movimiento}`, params, "post");
}

const getJustificacionSolicitud = async (params) => {
  return await http_client('/api/solicitudes/download-file-solcitud', params, "get", {}, true, "blob")
}

const getDocumentoSolicitud = async (params) => {
  return await http_client('/api/solicitudes/view-file', params, "get", {}, true, "blob")
}

const getDocAcuerdoAumento = async (params) => {
  return await http_client('/api/solicitudes/exportar-acuerdo', params)
}

const getDocCuadroAumento = async (params) => {
  // return await http_client('/api/solicitudes/get-pdf-cuadro-aumento', params, "post", {}, true, "blob")
  return await http_client('/api/solicitudes/get-pdf-cuadro-aumento', params, "post")
}

const getSubtitularesInstitucion = async (params) => {
  return await http_client('/api/solicitudes/get-subtitulares-institucion', params)
}

const patchDelegarSolicitud = async (id_movimiento, params) => {
  return await http_client(`/api/solicitudes/aumento/delegate/${id_movimiento}`, params, "patch");
}

// Ufi

// Entidad superior
const getSolicitudesEntidadSuperior = async (params = {}) => await http_client('/api/solicitudes/get-solicitudes-entidad-superior', params)

export default {
  getInstituciones,
  getCtlUnidadOrganizativa,
  getUnidadOrganizativa,
  getTiposDocumentos,
  showDocument,
  downloadDocument,
  getDescargarArchivo,
  // Empleado
  getEmpleadoPlazaDetalle,
  getDetalleSolicitudAumento,
  crearSolicitudAumento,

  // Jefe unidad
  getPersona,
  getSolicitudes,
  // RRHH
  descargarAcuerdoAumento,
  verAcuerdoAumento,
  rechazarSolicitudEmpleado,
  subirAcuerdoAumento,

  // Titular
  getDetailSolicById,
  postAprobarSolicitud,
  postRechazarSolicitud,
  getJustificacionSolicitud,
  getDocumentoSolicitud,
  getDocAcuerdoAumento,
  getDocCuadroAumento,
  getSubtitularesInstitucion,
  patchDelegarSolicitud,
  // Ufi

  getSolicitudesEntidadSuperior
};
